import { DatePeriod } from 'api/publist/models';
import { renderDate } from 'Detail/utils';
import { YearPeriod } from './types';

// Convert string inputs to YearPeriods for the store
export const yearStringsToPeriods = (years: string[], errorCallback: () => void): YearPeriod[] => {
  const periods = years
    .map((year) => {
      // Match ranges of format
      // xxxx       Single year
      // xxxx-yyyy  Range of years (both optional)
      const re = /^[\s]*(-?[0-9]{1,4})?([\s]*:[\s]*(-?[0-9]{1,4})?)?[\s]*$/;
      const match = re.exec(year);
      // Exclude result if it doesn't match (removed later with .filter())
      if (!match) {
        errorCallback();
        return undefined;
      }

      const start: number = match[1] !== undefined ? parseInt(match[1], 10) : undefined;
      const end: number = match[3] !== undefined ? parseInt(match[3], 10) : match[2] !== undefined ? undefined : start;
      // Reject empty input
      if (start === undefined && end === undefined) {
        errorCallback();
        return undefined;
      }
      // Reject backwards input
      if (start > end) {
        errorCallback();
        return undefined;
      }
      return { start, end };
    })
    .filter((period) => period !== undefined);

  return periods as YearPeriod[];
};
// Convert YearPeriods to string outputs for display
export const yearPeriodsToStrings = (years: YearPeriod[]): string[] => {
  return years.map((year) =>
    year.start === year.end
      ? `${year.start}`
      : `${undefined !== year.start ? year.start : ''}:${undefined !== year.end ? year.end : ''}`
  );
};

// Convert string inputs to YearPeriods for the store
export const dateStringsToPeriods = (ranges: string[]): DatePeriod[] => {
  const periods: DatePeriod[] = ranges
    .map((period) => {

      const periodSplit: string[] = period.split(' ~ ');
      const datePeriod: DatePeriod = {};

      if (periodSplit.length == 1) {
        datePeriod.start = new Date(periodSplit[0]);
      } else if (periodSplit.length == 2) {
        datePeriod.start = new Date(periodSplit[0]);
        datePeriod.end = new Date(periodSplit[1]);
      }
      return datePeriod;
    })
    .filter((period) => period !== undefined);

  return periods;
};

// Convert DatePeriods to string outputs for display
export const datePeriodsToStrings = (datePeriods: DatePeriod[]): string[] => {
  if (datePeriods === undefined) {
    return undefined;
  }
  return datePeriods.map((period) => {
    if (period.start !== undefined && period.end !== undefined) {
      return renderDate(period.start) + ' ~ ' + renderDate(period.end);
    } else if (period.start !== undefined && period.end === undefined) {
      return renderDate(period.start);
    }
  });
};